import { useState, useEffect, useRef } from "react";

// @see https://ionel-lupu.com/blog/onsticky-event-hook-in-react
const useSticky = () => {
	const ref = useRef();

	const [isSticky, setIsSticky] = useState(false);

	useEffect(() => {
		if (!ref.current || !("IntersectionObserver" in window)) {
			return;
		}

		const observer = new IntersectionObserver(
			([event]) => setIsSticky(event.intersectionRatio < 1),
			{ threshold: [1], rootMargin: "-1px 0px 0px 0px" }
		);
		observer.observe(ref.current);

		// eslint-disable-next-line consistent-return
		return () => observer.disconnect();
	}, [ref?.current]);

	return { ref, isSticky };
};

export default useSticky;
